import React from "react";
import "./Tabs.css";

interface TabTypeGeneric<EnumType> {
  id: number;
  title: string;
  content: React.ReactNode;
  tipoTab: EnumType;
  hide?: boolean;
}

interface TabsProps<EnumType> {
  tabs: TabTypeGeneric<EnumType>[];
  activeTab: EnumType;
  changeActiveTab: (tab: EnumType) => void;
  margin?: string;
}

const Tabs = <EnumType extends string | number>(props: TabsProps<EnumType>) => {
  const marginBottom = props.margin ?? "50px";

  const renderTabsTitle = () => {
    return (
      <>
        <div className="tabs">
          {props.tabs
            .filter((tab) => !tab.hide)
            .map((tab) => (
              <div
                key={tab.id}
                className={`tab ${props.activeTab === tab.tipoTab ? "active" : ""}`}
                onClick={() => {
                  props.changeActiveTab(tab.tipoTab);
                }}
              >
                {tab.title}
              </div>
            ))}
        </div>
        <hr style={{ margin: 0, marginBottom: marginBottom }} />
      </>
    );
  };

  const renderTabContent = () => {
    return (
      <div className="tab-content">
        {props.tabs
          .filter((tab) => !tab.hide)
          .map((tab) => (
            <div key={tab.id} className={`tab-pane ${props.activeTab === tab.tipoTab ? "active" : ""}`}>
              {props.activeTab === tab.tipoTab && tab.content}
            </div>
          ))}
      </div>
    );
  };

  return (
    <div className="tabs-container">
      {renderTabsTitle()}
      {renderTabContent()}
    </div>
  );
};

export default Tabs;
